module.exports = __webpack_public_path__ + "img/fires_and_gravy.1786cae1.jpg";